import React, { useEffect } from 'react'
import Skeleton from '@material-ui/lab/Skeleton'
import { useDispatch } from 'react-redux'
import moment from 'utils/momentInstanse'

import { useShallowEqualSelector } from 'custom-hooks'
import WhiteBlockWraper from 'components/CommonUI/WhiteBlockWraper/WhiteBlockWraper'
import LogoGroup from 'components/LogoGroup/LogoGroup'
import TileInfo from 'components/TileInfo/TileInfo'
import {
  getFacilityDataSelector,
  getFacility,
  selectIsFetchingFacility,
} from 'redux/reducers/facility'

const FacilityCurrentInfoBlock = ({ id }) => {
  const dispatch = useDispatch()

  const currentSingleLocation =
    useShallowEqualSelector(getFacilityDataSelector) || {}
  const isFetching = useShallowEqualSelector(selectIsFetchingFacility)

  const { name, city, current_temperature, group, image_uri, created_at } =
    currentSingleLocation

  const [first, last] = group?.name?.split(' ') || []

  const alt = `${first && first[0]}${(last && last[0]) || ''}`.toUpperCase()

  useEffect(() => {
    dispatch(getFacility(id))
  }, [dispatch, id])

  return (
    <WhiteBlockWraper className="facility_inform_card">
      <LogoGroup
        src={image_uri}
        classNameContainer="facility_inform_card_logo_container"
        alternative={alt}
      />
      <h3 className="facility_inform_card_title">
        {!isFetching ? (
          `${city?.name}, ${name}`
        ) : (
          <Skeleton variant="text" width={'100%'} />
        )}
      </h3>
      <TileInfo
        title="Current temperature"
        content={`${Number(current_temperature).toFixed(1) || 0} \u00B0C`}
        classNameContainer="facility_inform_card_temperature"
      />
      <div className="card-wrapper">
        <TileInfo
          title="Facility chain"
          content={group?.name}
          classNameContainer="facility_inform_card_fchain"
        />
        <TileInfo
          title="Monitoring since"
          content={moment.unix(created_at).format('MMM DD, YYYY')}
        />
      </div>
      {/* <ButtonStyled>
        <Arrows />
        <span className="button-compare">Compare</span>
      </ButtonStyled> */}
    </WhiteBlockWraper>
  )
}

export default FacilityCurrentInfoBlock
